import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { ErrorTranslationService } from '@bayclubs/utils';
import { BayclubsAlertService } from '@bayclubs/alert';

import { campsenum } from '../../../../../../../../models/enums.generated';
import { camps } from '../../../../../../../../models/models.generated';
import { SessionManagementApiService } from '../../../../../../../../services/api/session-management-api.service';
import { CampsDetailsFormBuilder } from '../../../../../camp-details-form-builder';
import { CampsDetailsFormStateService } from '../../../../../camp-details-form-state-service';
import { SessionsBasicInfoEditComponent } from '../edit/session-basic-info-edit.component';

@Component({
    selector: 'app-session-add',
    templateUrl: './session-add.component.html',
    styleUrls: ['./session-add.component.scss'],
    standalone: false
})
export class SessionAddComponent implements OnInit {
    public form: UntypedFormGroup;

    @Input() public campId: string;

    @ViewChild('sessionEditComponent', { static: true })
    private sessionEditComponent: SessionsBasicInfoEditComponent;

    context: camps.CampDefinitionCreationContext;

    constructor(
        public state: CampsDetailsFormStateService,
        private formBuilder: CampsDetailsFormBuilder,
        private api: SessionManagementApiService,
        private alert: BayclubsAlertService,
        private errorTranslate: ErrorTranslationService
    ) {}

    ngOnInit(): void {
        this.form = this.formBuilder.buildSessionInClub(
            <camps.SessionDefinitionDetails>{
                name: '',
                daysVariants: [],
                sessionDays: [{}],
                timeVariants: [{ type: campsenum.TimeRangeVariantType.FullDay, timeFromInMinutes: 480, timeToInMinutes: 960 }],
                club: { id: this.context.clubs[0].id },
                options: [],
                ageRangeFromInMonths: 36,
                ageRangeFromInMonthsEffective: 36,
                ageRangeToInMonths: 72,
                ageRangeToInMonthsEffective: 84,
                description: '',
                allowCampCreditPointsUsage: true,
                allowCustomVariantSelection: true
            },
            this.campId
        );
    }

    public get basicInfoForm(): UntypedFormGroup {
        return this.form.controls['basicInfo'] as UntypedFormGroup;
    }

    public onSave() {
        var request = this.sessionEditComponent.getRequest();

        this.api.save(request).subscribe(x => {
            if (x.isSuccess) {
                this.alert.showOperationSuccess();
                this.state.sessionChanged.emit(x.value.id);
                this.closeModal();
            } else {
                this.errorTranslate.translateValidationNotifications(x.validationNotification);
                this.alert.showError(x.validationNotification.errors[0].message);
            }
        });
    }

    public cancel() {
        this.closeModal();
    }

    public onClose() {
        this.closeModal();
    }

    close: Function;
    closeModal(): void {
        this.log();
        this.close();
    }

    public log() {
        console.log(this.basicInfoForm);
    }

    public isFormValid() {
        return this.sessionEditComponent.isFormValid();
    }
}
